// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Qogr","left":"InfoRow_left__muC2D"};